import { GoTrash } from "react-icons/go";
import { IoIosClose } from "react-icons/io";
import { usePopUpsStore } from "../../store/PopUpStore";

interface PopUpDeleteProps {
  text: string;
  onClickDelete?: () => void;
}

const PopUpDelete = ({ text, onClickDelete }: PopUpDeleteProps) => {
  const { popUpDelete, setPopUpDelete } = usePopUpsStore();

  return (
    <div
      className={`${
        popUpDelete[1] ? "" : "hidden"
      } flex justify-center items-center h-full w-full fixed top-0 left-0 z-[100000]`}
    >
      <div
        className="fixed w-full h-full bg-black/30 z-[100001]"
        onClick={() => setPopUpDelete(["", false])}
      />
      <div className="bg-white flex flex-col rounded-xl p-5 z-[100002] min-w-1/3 min-h-1/3">
        <div
          className="flex p-1 bg-gray-100 w-fit rounded-full cursor-pointer"
          onClick={() => setPopUpDelete(["", false])}
        >
          <IoIosClose size={25} />
        </div>
        <div className="flex flex-col gap-10">
          <div className="flex flex-col gap-3 items-center">
            <GoTrash color="#435351" size={40} className="-rotate-[15deg]" />
            <h2 className="text-[#54595E] text-xl">{text}</h2>
          </div>
          <div className="flex flex-col gap-2">
            <button
              onClick={onClickDelete}
              className="text-lg bg-red-600 hover:bg-red-500 text-white font-semibold rounded-lg w-full p-2"
            >
              تأكيد
            </button>
            <button
              onClick={() => setPopUpDelete(["", false])}
              className="text-lg bg-white border border-primary text-primary font-semibold rounded-lg w-full p-2"
            >
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUpDelete;
